import React from 'react';
import { Block } from '../../../components';
import { Button as LinkButton } from '../../procedures/components/LinkProcedureAmount/styled';
import iconWhatsapp from '../../../../assets/icons/icon-whatsapp-grey.svg';
import iconPhone from '../../../../assets/icons/icon-phone-empty.svg';
import { ContainerInfo } from '../styles';

interface NotEnrolledInfoProps {
  isAdmin?: boolean;
}

const NotEnrolledInfo = (props: NotEnrolledInfoProps) => {
  const { isAdmin } = props;
  const handlerRedirectNewPage = (url: any) => {
    window.open(url, '_blank');
  };
  return (
    <ContainerInfo isAdmin={isAdmin}>
      <Block>
        <div className="textTitle">Tu matrícula está en proceso</div>
        <div className="textInfo" style={{ marginBottom: '16px' }}>
          Si necesitas ayuda comunícate con el{' '}
          <b>Servicio de Atención al Estudiante (SAE)</b>
        </div>
        <div className="column">
          <div className="textInfo">
            <span>
              <img src={iconPhone} alt="" />
              <b>Llama a los siguientes números:</b>
            </span>
            <p>
              Lima:{' '}
              <LinkButton
                data-testid="cmp-link-open-whatsapp"
                className="link"
                onClick={() => handlerRedirectNewPage('tel:013159600')}
              >
                <span>(01) 315 9600</span>
              </LinkButton>
            </p>
            <p>
              Provincia:{' '}
              <LinkButton
                data-testid="cmp-link-open-whatsapp"
                className="link"
                onClick={() => handlerRedirectNewPage('tel:080119600')}
              >
                <span> 0801 19 600 (opción 1)</span>
              </LinkButton>
            </p>
          </div>
          <div className="textInfo">
            <span>
              <img src={iconWhatsapp} alt="" />
              <b>Escríbenos por:</b>
            </span>
            <p>
              Whatsapp:{' '}
              <LinkButton
                data-testid="cmp-link-open-whatsapp"
                className="link"
                // onClick={openLink}
                onClick={() =>
                  handlerRedirectNewPage(
                    'https://api.whatsapp.com/send?phone=51960252970&text=Hola%2C%20soy%20alumno%20UTP%20y%20deseo%20hacer%20una%20consulta'
                  )
                }
              >
                <span>960 252 970</span>
              </LinkButton>
            </p>
          </div>
        </div>
      </Block>
    </ContainerInfo>
  );
};

export default NotEnrolledInfo;
